import {
  FilterType,
  buildExpensableGroupsDataTableFilter,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'

const pendingApprovalFilter = ({
  source,
  expensesContext,
  initialFilterValues,
}: BaseFilterProps) => {
  const options = [
    {
      label: i18n.t('expenses_v2.list.filters.mine'),
      value: 'mine',
    },
    {
      label: i18n.t('expenses_v2.list.filters.all'),
      value: 'all',
    },
  ]

  return buildExpensableGroupsDataTableFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
        value: initialFilterValues.pendingApproval
          ? initialFilterValues.pendingApproval
          : undefined,
      },
    ],
    identifier: 'expensesList.pendingApprovalFilter',
    path: 'pendingApproval',
    title: i18n.t('expenses_v2.list.filters.pending_approval'),
    default: !!initialFilterValues.pendingApproval,
  })
}

export default pendingApprovalFilter
